<template>
    <div class="classify-picture-wrap">
        <MaterialTrees @getItemDetail="getItemDetail"></MaterialTrees>
        <div class="classify-picture-content">
            <PictureTopOperateBar :sourceData="sourceData" :refercence="refercence" @switchClick="switchHandler"></PictureTopOperateBar>
            <div class="classify-picture-list" @dragover.prevent="dragoverHandle">
                <FigureItem v-for="item in classifyPictureData" :key="item.id" :data="item"
                    @checkedClick="itemCheckChange" @editClick="editHandler" @previewClick="previewHandler"
                    :iconConfig="iconData"/>
                <span class="no-data-tip" v-if="classifyPictureData.length == 0">{{$t("zhiji.common.noData")}}</span>
                <DragUploadPanel :isShowDrag="isDrag" :isShowTip="isShowDragTip" @dropClick="dropHandle"></DragUploadPanel>
            </div>
            <div class="page-control">
                <BottomOperateBar :allCheck="allCheckFlag" @allCheckChange="allCheckHandler"
                    @deleteClick="deleteChecked" v-if="!refercence"/>
                <PageControl :total="totalPage" :curPage="curPage" :pageLength="curPageLen"
                    @pageChange="pageChange" />
                <div class="page-length-rank">
                    <span class="total-num">{{$t("zhiji.materialLibrary.totalOf") + totalPage}}</span>
                    <PageLengthSelect class="length-rank-robot" :pageRank="pageLengthRank"
                        :curLength="curPageLen" @lengthChange="lengthChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaterialTrees from '@/views/zhiji/components/materialLibrary/MaterialTrees';
import FigureItem from "@/views/zhiji/components/materialLibrary/FigureItem";
import BottomOperateBar from "@/views/zhiji/components/materialLibrary/BottomOperateBar";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import PictureTopOperateBar from "./PictureTopOperateBar";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";
import DragUploadPanel from "./DragUploadPanel";
import ImageViewModal from "@/views/zhiji/components/questionEdit/modals/ImageViewModal";
import PictureEditModel from "./PictureEditModel";

import { sourceOptions, pageLengthRank } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "VLinkPicture",
    props: ['refercence'],
    components: {
        MaterialTrees,
        PictureTopOperateBar,
        FigureItem,
        PageControl,
        BottomOperateBar,
        PageLengthSelect,
        DragUploadPanel
    },
    data() {
        return {
            iconData: {
                amountIcon: "-361px -54px",
                previewIcon: "-145px -50px",
                previewHoverIcon: "-145px -74px",
            },
            curPage: 1,
            curPageLen: 15,
            checkedArr: [],
            sourceData: sourceOptions,
            pageLengthRank: pageLengthRank,
            isDrag: false,
        }
    },
    computed: {
        classifyPictureData() {
            return this.convertListData(this.getStorePorp("pictureData"));
        },
        totalPage() {
            return this.getStorePorp("pictureTotal");
        },
        allCheckFlag() {
            return this.checkedArr.length !== 0 && this.classifyPictureData.length == this.checkedArr.length;
        },
        isShowDragTip() {
            return this.classifyPictureData.length == 0;
        }
    },
    mounted() {
        this.getClassifyPictureList();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        getItemDetail(data) {
            this.$store.dispatch("zhiji/queryPictureList", {
                tagId: data.isRoot ? "" : data.tagId,
                page: 1,
            });
            this.curPage = 1;
        },
        getClassifyPictureList() {
            this.$store.dispatch("zhiji/queryPictureList", {
                page: this.curPage,
                size: this.curPageLen,
                pictureName: '',
                source: '',
                sequence: '',
                tagId: '',
            });
        },
        editHandler(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: PictureEditModel,
                data: {
                    type: "edit",
                    pictureData: data,
                }
            });
        },
        previewHandler(data) {
            this.$store.commit("zhiji/showModal", {
                type: ImageViewModal,
                data: {
                    url: data.url,
                },
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.$store.dispatch("zhiji/queryPictureList", {
                page: this.curPage,
                size: this.curPageLen,
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        lengthChange(data) {
            if (this.curPageLen == data) {
                return;
            }
            this.curPageLen = data;
            this.$store.dispatch("zhiji/queryPictureList", {
                page: this.curPage,
                size: this.curPageLen,
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedArr.indexOf(data.id) === -1 && this.checkedArr.push(data.id);
            } else {
                let itemcheckedIdx = this.checkedArr.indexOf(data.id);
                itemcheckedIdx !== -1 && this.checkedArr.splice(itemcheckedIdx, 1);
            }
            this.$emit("checkClick", data);
        },
        allCheckHandler(data) {
            data.checked ? this.addAllCheck() : this.removeAllCheck();
        },
        addAllCheck() {
            this.classifyPictureData.forEach((item) => {
                this.itemCheckChange({
                    id: item.id,
                    checked: true,
                })
            })
        },
        removeAllCheck() {
            this.checkedArr.splice(0);
        },
        deleteChecked() {
            let configText = i18n.t("zhiji.materialLibrary.deletePicConfim");
            this.checkedArr.length === 0 ? configText = i18n.t("zhiji.materialLibrary.operatWarning") :
            this.checkedArr.length > 1 ? configText = i18n.t("zhiji.materialLibrary.delPicturesConfim") : '';
            this.$store.dispatch('zhiji/showModal', {
                type: 'MessageModal',
                data: {
                    type: 'tip',
                    message: configText,
                    confirm: (data) => {
                        if(this.checkedArr.length > 0) {
                            this.deletePicture();
                            this.removeAllCheck();
                        }
                    }
                }
            });
        },
        deletePicture() {
            this.zhiji.requestByServiceName("deletePicture", {
                pictureIds: this.checkedArr.join(","),
            }).then(result => {
                this.$store.dispatch("zhiji/queryPictureList", {
                    page: this.curPage,
                    size: this.curPageLen,
                });
            });
        },
        convertListData(data) {
            return data.map((item) => {
                return {
                    ...item,
                    checked: this.getCheckState(item.id),
                }
            })
        },
        getCheckState(id) {
            return this.checkedArr.some(itemId => itemId === id);
        },
        switchHandler() {
            this.curPage = 1;
            this.checkedArr = [];
            this.$emit("checkClick", {});
        },
        dragoverHandle() {
            this.isDrag = true;
        },
        dropHandle() {
            this.isDrag = false;
        }
    }
}
</script>

<style scoped lang="scss">
    .classify-picture-wrap {
        height: 100%;
        display: flex;
        .classify-picture-content {
            display: flex;
            flex: 1;
            flex-direction: column;
            .classify-picture-list {
                display: flex;
                flex: 1;
                justify-content: flex-start;
                align-content: flex-start;
                flex-wrap: wrap;
                background-color: #fff;
                padding: 24px 0 24px 24px;
                box-sizing: border-box;
                overflow-y: auto;
                position: relative;
                .no-data-tip {
                    width: 100%;
                    text-align: center;
                    margin-top: -10px;
                    color: #9B9BA3;
                }
            }
            .page-control {
                position: relative;
                width: 100%;
                padding: 20px 0;
                text-align: center;
                background: #f2f7fb;
                .page-length-rank {
                    margin-right: 20px;
                    float: right;
                    margin-top:6px;
                    .total-num {
                        font-weight: 700;
                        margin-right: 10px;
                    }
                    .length-rank-robot {
                        top: -2px;
                    }
                }
            }
        }
    }
</style>
